import LiveBroadcastStore from "../../../LiveBroadcastStore";
import PayPerViewStore from "../../../PayPerViewStore";
import TulumRealityShowStore from "../../../TulumRealityShowStore";

export function usersPresenceEventHandler(event) {
  if (event.type === 'add') {
    this.usersPresence.set(event.value, true);
  }
  if (event.type === 'remove') {
    this.usersPresence.set(event.value, false);
  }
}

export function systemEventsHandler(event) {
  LiveBroadcastStore.setStreamEventNotification(event);
  TulumRealityShowStore.checkForEventShowsFromNotification(event);
  this.rootStore.uiStore.notify(event);
}

export function globalSessionEventsHandler(event) {
  if (!event) {
    console.error('No event sent! event info:', event);

    return;
  }

  if (event.type === 'CUSTOM' && event.content && event.content.type === 'purchaseNotifyEvent') {
    PayPerViewStore.purchaseNotifyEventHandler(event);
  }

  if (event.type === 'CUSTOM' && event.content &&
    (event.content.type === 'EnableCanWriteMessagesInNonFanConversation' ||
      event.content.type === 'DisableCanWriteMessagesInNonFanConversation')) {
    this.updateChatState(event.content);
  }

  if (
    event.type === 'CONVERSATION_MESSAGE' &&
    this.rootStore.uiStore.shouldGetNumOfConversationsWithUnreadMessages) {
    this.rootStore.uiStore.getNumOfConversationsWithUnreadMessages();
  }
  // Ignore the new messages of type 'CUSTOM' - Anchors
  // They should appear in the chat preview only for fans
  const anchorMassMessage = event &&
    event.content.type === 'CUSTOM' &&
    event.content.details.type !== 'tippingMessage' &&
    this.rootStore.loggedInUser.account.anchor;

  if (event && this.conversations.data.length && !anchorMassMessage) {
    if (event.type === 'CONVERSATION_MESSAGE') {
      // if (this.activeConversationName !== event.content.conversationName) {
      if (this.activateConversation.name !== event.content.conversationName) {
        this.conversations.data.forEach((c) => {
          if (c.name === event.content.conversationName) {
            if (event.content.type === 'CUSTOM') {
              c.lastCustomMessage = event.content;
            } else {
              c.lastStandardMessage = event.content;
            }
          }
        });
      }

      // Anchor Side - Check if the incoming conversation is already in the list (new conversations won't be in the list)
      const conversationExists = this.conversations.data.
        filter((c) => c.name === event.content.conversationName).
        length === 1;

      // If it's not, than it's a new conversation (fan => anchor) - refresh the list to display it
      if (!conversationExists) {
        this.loadPrivateChatData();
      }
    }
  }

  const conversationExists = this.conversations.data.
    filter((c) => c.name === event.content.conversationName).
    length === 1;

  // Fan Side - if the conversation is coming through the global session, we need to refresh the list
  // Conversation will exist even if it's empty (on the fan's side), so we'll update the list with the new conversation (anchor => fan)
  if (!this.rootStore.loggedInUser.account.anchor && conversationExists) {
    this.loadPrivateChatData();
  }
  this.globalPresenceSession.lastEventData = event;
}

export function onConversationEvents(event) {
  if (event) {
    if (event.type === 'MESSAGE') {
      if (this.activeConversationMessages.length === 0) {
        this.activeConversationMessages.push(event.content);
        this.conversationSession.session.updateLastReadTimestamp(event.content.timestamp);
      } else if (event.content.timestamp !== this.activeConversationMessages[this.activeConversationMessages.length - 1].timestamp) {
        this.activeConversationMessages.push(event.content);
        this.conversationSession.session.updateLastReadTimestamp(event.content.timestamp);
      }
    }
    if (event.type === 'LAST_READ_UPDATE') {
      this.conversations.data.filter((c) => c.name === this.activeConversationName)[0].members.forEach((m) => {
        if (m.username.toLowerCase() === event.content.username) {
          m.lastReadTimestamp = event.content.timestamp;
        }
      });
    }
  }
}

